import React, { useEffect, useState } from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

const SessionWarningModal = React.memo(({ remainingMs, onStay, onSignOut }) => {
  const [seconds, setSeconds] = useState(Math.max(0, Math.ceil(remainingMs / 1000)))

  useEffect(() => {
    setSeconds(Math.max(0, Math.ceil(remainingMs / 1000)))
    const timer = setInterval(() => setSeconds((s) => (s > 0 ? s - 1 : 0)), 1000)
    return () => clearInterval(timer)
  }, [remainingMs])

  return (
    <Modal isOpen centered backdrop='static' keyboard={false}>
      <ModalHeader>Still there?</ModalHeader>
      <ModalBody>
        You have been inactive for a while. You will be signed out in {seconds} second{seconds === 1 ? '' : 's'}.
      </ModalBody>
      <ModalFooter>
        <Button color='light' onClick={onSignOut}>Sign out</Button>
        <Button color='primary' onClick={onStay}>Stay signed in</Button>
      </ModalFooter>
    </Modal>
  )
})

export default SessionWarningModal
